<template>
  <div class="dash-container">
    <div class="dash-box">
      <div class="dash-text">{{ dashText }}</div>
      <div class="dash-icons-container">
        <div style="flex: 1"></div>
        <div class="dash-icon dash-icon-params" @click="setMapView(1)" v-bind:class="{ 'dash-icon-selected': currentMapView==1 }" @mouseover="setDashText(1)" @mouseleave="setDashText(currentMapView)"></div>
        <!-- <div class="dash-icon dash-icon-subbottom" @click="setMapView(2)" v-bind:class="{ 'dash-icon-selected': currentMapView==2 }" @mouseover="setDashText(2)" @mouseleave="setDashText(currentMapView)"></div> -->
        <div class="dash-icon dash-icon-mosaics" @click="setMapView(3)" v-bind:class="{ 'dash-icon-selected': currentMapView==3 }" @mouseover="setDashText(3)" @mouseleave="setDashText(currentMapView)"></div>
        <div class="dash-icon dash-icon-bathymetry" @click="setMapView(4)" v-bind:class="{ 'dash-icon-selected': currentMapView==4 }" @mouseover="setDashText(4)" @mouseleave="setDashText(currentMapView)"></div>
        <div class="dash-icon dash-icon-sonar" @click="setMapView(5)" v-bind:class="{ 'dash-icon-selected': currentMapView==5 }" @mouseover="setDashText(5)" @mouseleave="setDashText(currentMapView)"></div>
        <div style="flex: 1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dash",
  props: {
    defaultCurrentMapView: '',
  },
  data() {
    return {
      dashText: ''
    };
  },
  computed: {
    currentMapView: {
        set (viewId) { this.$store.dispatch('ui/change_current_map_view', viewId); },
        get () { return this.$store.state.ui.current_map_view }
    },
  },
  mounted () {
    if (!this.currentMapView && this.$route.name == 'MapParams') {
      this.setMapView(1)
    }else if((!this.currentMapView && this.$route.name == 'Map') ||(this.currentMapView == 3 && this.$route.name == 'Map') ){
      this.setMapView(3)
    } 
  },
  methods: {
    setMapView: function (viewId) {
      if(this.currentMapView != viewId){
        this.currentMapView = viewId
        this.setDashText(viewId)
      }
    },
    setDashText: function (viewId) {
      switch (viewId) {
        case 1:
          this.dashText = "Parámetros oceanográficos"
          break
        case 2:
          this.dashText = "Sub bottom"
          break
        case 3:
          this.dashText = "Mosaicos fotográficos"
          break
        case 4:
          this.dashText = "Batimetrías"
          break
        case 5:
          this.dashText = "Sonar de barrido lateral"
          break
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dash-container {
  z-index: 1000;
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.dash-box {
  background-color: #F4FAFE;
  /* height: 50px; */
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  pointer-events: all;
}
.dash-icons-container {
  display: flex;
  flex-direction: row;
}
.dash-icon {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  height: 45px;
  width: 45px;
  cursor: pointer;
  opacity: 0.4;
}
.dash-icon:hover {
  background-size: 90%;
  opacity: 1;
}
.dash-icon-selected {
  background-size: 90%;
  opacity: 1;
}
.dash-text {
  display: flex;
  align-items: center;
  justify-content: center;;
  color: #447998;       
  font-size: 0.8rem;
  margin: 8px;
}
.dash-icon-params {
  background-image: url('~@/assets/icons/icon-dash-params.svg');
}
.dash-icon-subbottom {
  background-image: url('~@/assets/icons/icon-dash-subbottom.svg');
}
.dash-icon-bathymetry {
  background-image: url('~@/assets/icons/icon-dash-bathymetry.svg');
}
.dash-icon-mosaics {
  background-image: url('~@/assets/icons/icon-dash-mosaics.svg');
}
.dash-icon-sonar {
  background-image: url('~@/assets/icons/icon-dash-sonar.svg');
}

/* TRANSITIONS */
.dash-icon {
  -webkit-transition: .15s ease-in-out;
  -moz-transition: .15s ease-in-out;
  -o-transition: .15s ease-in-out;
  transition: .15s ease-in-out; 
}
</style>



// WEBPACK FOOTER //
// src/components/MapDash.vue